import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { serverSummaryCurrency, serverSummary } from "@/api/dataAll/dataAll"; // import { screenDataAdd, screenDataGet } from "@/api/user";

import * as echarts from "echarts";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "serverSummaryData",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      searchData: {
        kind: 1,
        all_countries: 0,
        pay_channel: ''
      },
      pageData: {},
      tableData: [],
      tableList: [{
        label: this.$t('date'),
        prop: 'date'
      }, {
        label: this.$t('serverId'),
        prop: 'server_id'
      }, {
        label: this.$t('serverName'),
        prop: 'server_name'
      }, {
        label: this.$t('iapRevenue'),
        prop: 'total_pay_amount'
      }, {
        label: this.$t('payAccountCount'),
        prop: 'pay_user_count'
      }, {
        label: this.$t('payRoleCount'),
        prop: 'pay_role_count'
      }, {
        label: this.$t('activeAccountCount'),
        prop: 'active_user_count'
      }, {
        label: this.$t('activeRoleCount'),
        prop: 'active_role_count'
      }, {
        label: this.$t('newAccountCount'),
        prop: 'new_user_count'
      }, {
        label: this.$t('registerRechargePnum'),
        prop: 'new_user_pay_count'
      }, {
        label: this.$t('newRoleCount'),
        prop: 'new_role_count'
      }, {
        label: this.$t('newRolePayCount'),
        prop: 'new_role_pay_count'
      }, {
        label: this.$t('arppuActiveUser'),
        prop: 'arppu_active_user'
      }, {
        label: this.$t('arppuActiveRole'),
        prop: 'arppu_active_role'
      }, {
        label: this.$t('arppuPayUser'),
        prop: 'arppu_pay_user'
      }, {
        label: this.$t('arppuPayRole'),
        prop: 'arppu_pay_role'
      }, {
        label: this.$t('newUserPayAmount'),
        prop: 'new_user_pay_amount'
      }, {
        label: this.$t('newRolePayAmount'),
        prop: 'new_role_pay_amount'
      }, {
        label: this.$t('newUserPayRate'),
        prop: 'new_user_pay_rate'
      }, {
        label: this.$t('newRolePayRate'),
        prop: 'new_role_pay_rate'
      }],
      screenData: null,
      screenDataShow: false
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.searchData.env_id = _this.szgmEnv.length ? _this.szgmEnv[0].id : '';

              if (_this.rawData.game_mark.indexOf('yjfm') == -1) {
                _this.getServer();
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    selecRotAll: function selecRotAll() {
      var _this2 = this;

      this.paramsData.server_id = [];

      if (this.checked) {
        this.serverList.map(function (item) {
          _this2.paramsData.server_id.push(item.serverID);
        });
      } else {
        this.paramsData.server_id = [];
      }
    },
    getServer: function getServer() {
      var _this3 = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this3.serverList = res.data;
        }
      });
    },
    searchClickNs: function searchClickNs() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var searchCurrency, reqFn;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.timeInterval();

              case 2:
                searchCurrency = _this4.$store.state.d2admin.serchSelect.searchCurrency;
                reqFn = searchCurrency.length ? serverSummaryCurrency : serverSummary;
                _this4.reqLoading = true;
                _context2.next = 7;
                return _this4.getexchangeRate();

              case 7:
                _this4.searchData.server_id = _this4.paramsData.server_id;

                _this4.searchClickPoints(reqFn, 1, ['start_time', 'end_time']);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    searchClick: function searchClick(lists) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var qres, totalDataList, list, finalTotal;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                qres = JSON.parse(JSON.stringify(lists));
                _this5.tableData = [];
                totalDataList = [];
                list = _this5.rawData.game_mark.indexOf('royalpirates') > -1 ? _this5.serverList : _this5.serverListYJ;
                qres.forEach(function (dayData) {
                  var _this5$tableData;

                  // 将当天的详细数据添加到表格数据中
                  dayData.data.forEach(function (item) {
                    var foundData = list.find(function (b) {
                      return b.serverID == item.server_id;
                    });
                    item.server_name = foundData ? foundData.serverName : '/';
                    item.arppu_active_user = item.arppu_active_user ? item.arppu_active_user.toFixed(2) : 0;
                    item.arppu_active_role = item.arppu_active_role ? item.arppu_active_role.toFixed(2) : 0;
                    item.arppu_pay_user = item.arppu_pay_user ? item.arppu_pay_user.toFixed(2) : 0;
                    item.arppu_pay_role = item.arppu_pay_role ? item.arppu_pay_role.toFixed(2) : 0;
                  });

                  (_this5$tableData = _this5.tableData).push.apply(_this5$tableData, _toConsumableArray(dayData.data)); // 将当天的总计数据存储起来


                  totalDataList.push(dayData.total);
                });
                finalTotal = _this5.calculateTotal(totalDataList); // 将总计行添加到表格数据中

                _this5.tableData.push(finalTotal);

                console.log("this.tableData", _this5.tableData);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    calculateTotal: function calculateTotal(totalDataList) {
      var finalTotal = {
        date: this.$t('total')
      }; // 需要求和的字段列表

      var sumFields = ['new_user_count', 'new_role_count', 'new_role_pay_count', 'active_user_count', 'active_role_count', 'pay_user_count', 'pay_role_count', 'total_pay_amount', 'new_user_pay_amount', 'new_role_pay_amount', 'new_user_pay_count']; // 初始化求和字段

      sumFields.forEach(function (field) {
        finalTotal[field] = 0;
      }); // 计算总和

      totalDataList.forEach(function (totalData) {
        sumFields.forEach(function (field) {
          finalTotal[field] += Number(totalData[field]) || 0;
        });
      });
      finalTotal.total_pay_amount = finalTotal.total_pay_amount.toFixed(2);
      finalTotal.new_user_pay_amount = finalTotal.new_user_pay_amount.toFixed(2);
      finalTotal.new_role_pay_amount = finalTotal.new_role_pay_amount.toFixed(2);
      finalTotal.arppu_active_user = finalTotal.active_user_count ? (finalTotal.total_pay_amount / finalTotal.active_user_count).toFixed(2) : 0;
      finalTotal.arppu_active_role = finalTotal.active_role_count ? (finalTotal.total_pay_amount / finalTotal.active_role_count).toFixed(2) : 0;
      finalTotal.arppu_pay_user = finalTotal.pay_user_count ? (finalTotal.total_pay_amount / finalTotal.pay_user_count).toFixed(2) : 0;
      finalTotal.arppu_pay_role = finalTotal.pay_role_count ? (finalTotal.total_pay_amount / finalTotal.pay_role_count).toFixed(2) : 0;
      finalTotal.new_user_pay_rate = finalTotal.new_user_count ? (finalTotal.new_user_pay_count / finalTotal.new_user_count * 100).toFixed(2) + '%' : '0';
      finalTotal.new_role_pay_rate = finalTotal.new_role_count ? (finalTotal.new_role_pay_count / finalTotal.new_role_count * 100).toFixed(2) + '%' : '0';
      return finalTotal;
    },
    exportdata: function exportdata() {
      var data = this.tableData;
      var columns = this.tableList;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};